import React from 'react';
import PropTypes from 'prop-types';
import { Pagination as BootstrapPagination } from 'react-bootstrap/lib';

const PER_PAGE = 10;
const SURROUND_PAGES = 5;

/**
 * Custom pagination component based on boostrap. Provides easier navigation across the pages.
 */
function Pagination(props) {
  const page = props.page || 1;
  const total = props.total || 0;
  const perPage = props.perPage || PER_PAGE;

  const totalPages = Math.ceil(total / perPage);
  const paginationItems = [];
  for (
    let p = Math.max(1, page - SURROUND_PAGES);
    p <= Math.min(totalPages, page + SURROUND_PAGES);
    p += 1
  ) {
    paginationItems.push(
      <BootstrapPagination.Item
        key={p}
        active={page === p}
        onClick={() => props.setPage(p)}
      >
        {p}
      </BootstrapPagination.Item>,
    );
  }
  paginationItems.unshift(
    <BootstrapPagination.Prev
      key="prev"
      disabled={page === 1}
      onClick={() => props.setPage(Math.max(1, page - 1))}
    />,
  );
  paginationItems.push(
    <BootstrapPagination.Next
      key="next"
      disabled={page === totalPages}
      onClick={() => props.setPage(Math.min(totalPages, page + 1))}
    />,
  );

  return totalPages > 1 ? (
    <BootstrapPagination>{paginationItems}</BootstrapPagination>
  ) : null;
}

Pagination.propTypes = {
  page: PropTypes.number,
  total: PropTypes.number,
  perPage: PropTypes.number,
  setPage: PropTypes.func,
};

export default Pagination;
